import { tg } from "./webapp";

/**
 * Publishes the usable height and safe-area insets as CSS variables.
 *
 * Telegram's viewport is not the visual viewport: the client animates it while
 * the keyboard opens and while the app expands, and on fullscreen clients the
 * header overlaps the top of the WebView. Laying out against 100dvh alone puts
 * the bottom CTA underneath the home indicator on most phones.
 */
export function watchViewport(): () => void {
  const root = document.documentElement;

  const apply = () => {
    const height = tg?.viewportStableHeight || window.innerHeight;
    root.style.setProperty("--tg-viewport", `${height}px`);

    // safeAreaInset is device chrome; contentSafeAreaInset is Telegram's own.
    const device = tg?.safeAreaInset;
    const content = tg?.contentSafeAreaInset;
    if (device || content) {
      const top = (device?.top ?? 0) + (content?.top ?? 0);
      const bottom = (device?.bottom ?? 0) + (content?.bottom ?? 0);
      root.style.setProperty("--safe-top", `${top}px`);
      root.style.setProperty("--safe-bottom", `${bottom}px`);
    } else {
      root.style.setProperty("--safe-top", "env(safe-area-inset-top, 0px)");
      root.style.setProperty("--safe-bottom", "env(safe-area-inset-bottom, 0px)");
    }
  };

  apply();

  const app = tg;
  if (!app) {
    window.addEventListener("resize", apply);
    return () => window.removeEventListener("resize", apply);
  }

  app.onEvent("viewportChanged", apply);
  app.onEvent("safeAreaChanged", apply);
  app.onEvent("contentSafeAreaChanged", apply);
  return () => {
    app.offEvent("viewportChanged", apply);
    app.offEvent("safeAreaChanged", apply);
    app.offEvent("contentSafeAreaChanged", apply);
  };
}
